import { useToggle } from 'usehooks-ts'

import { DropdownMenu } from 'components/DropdownMenu'

import { HelpAndFeedbackMenuButton } from './components/HelpAndFeedbackMenuButton'
import { HelpAndFeedbackMenuContent } from './components/HelpAndFeedbackMenuContent'

import type { FC } from 'react'

export const HelpAndFeedbackMenu: FC = () => {
  const [isHelpAndFeedbackMenuOpen, toggleHelpAndFeedbackMenu]
    = useToggle(false)

  return (
    <DropdownMenu open={isHelpAndFeedbackMenuOpen}>
      <HelpAndFeedbackMenuButton
        isHelpAndFeedbackMenuOpen={isHelpAndFeedbackMenuOpen}
        onToggleHelpAndFeedbackMenu={toggleHelpAndFeedbackMenu}
      />
      <HelpAndFeedbackMenuContent
        onToggleHelpAndFeedbackMenu={toggleHelpAndFeedbackMenu}
      />
    </DropdownMenu>
  )
}
